// assets/ce-datalayer.js — add_to_cart por origem da oferta e begin_checkout (GA4)
// Cada evento vai para o dataLayer (para um futuro contêiner GTM) e, se existir gtag, também por gtag('event', ...).
(function () {
  const push = window.ceTrack || ((name, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: name, ecommerce });
    if (typeof gtag === 'function') gtag('event', name, ecommerce);
  });
  const itemFromCart = (line, origem, qty) => ({
    item_id: line.sku || String(line.variant_id),
    item_name: line.product_title,
    item_brand: line.vendor,
    item_variant: line.variant_title,
    price: line.price / 100,
    quantity: qty,
    item_list_name: origem
  });
  const addEvent = (items) => push('add_to_cart', { currency: 'BRL', value: items.reduce((a, i) => a + i.price * i.quantity, 0), items });

  // Último carrinho conhecido, para o begin_checkout sair de forma síncrona
  let lastCart = null;
  const refreshCart = () => fetch('/cart.js').then((r) => r.json()).then((c) => { lastCart = c; return c; });
  refreshCart().catch(() => {}); // o begin_checkout precisa de um carrinho em cache mesmo sem nenhuma adição na página

  // Adições feitas pela camada ce-* (compre-junto, kit, bump, sugestao-sacola, ce-cart...).
  // Remoções e o brinde (R$ 0, adicionado automaticamente) ficam de fora.
  document.addEventListener('ce:cart:changed', (e) => {
    const { origem, items, cart } = e.detail || {};
    if (cart && cart.items) lastCart = cart;
    const o = String(origem || '');
    if (!cart || !items || !items.length || /remove/.test(o) || o === 'brinde') return;
    const added = new Map(); // variant_id -> { line, qty } (quantidade pedida, não o total da linha)
    items.forEach((i) => {
      if (!i || Number(i.quantity) === 0) return;
      const line = i.id != null ? cart.items.find((l) => l.variant_id === Number(i.id)) : cart.items[Number(i.line) - 1];
      if (!line) return;
      const qty = Number(i.quantity) > 0 ? Number(i.quantity) : 1;
      const prev = added.get(line.variant_id);
      added.set(line.variant_id, { line, qty: (prev ? prev.qty : 0) + qty });
    });
    if (!added.size) return;
    addEvent([...added.values()].map(({ line, qty }) => itemFromCart(line, o || 'ce-cart', qty)));
  });

  // Adição nativa do formulário do produto (a camada ce-cart também publica cartUpdate, com outro source: ignorado)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (!ev) return;
      const native = ev.source === 'product-form' && ev.productVariantId;
      const qtyInput = native && document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      refreshCart().then((cart) => {
        if (!native) return;
        const l = (cart.items || []).find((x) => String(x.variant_id) === String(ev.productVariantId));
        if (l) addEvent([itemFromCart(l, 'pdp', qty)]);
      }).catch(() => {});
    });
  }

  // begin_checkout em fase de captura, antes da navegação; usa o carrinho em cache e só busca /cart.js sem cache
  let lastCheckout = 0;
  const sendCheckout = (cart) => push('begin_checkout', { currency: 'BRL', value: cart.total_price / 100, items: (cart.items || []).map((l) => itemFromCart(l, 'sacola', l.quantity)) });
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('#CartDrawer-Checkout, button[name="checkout"], a[href="/checkout"]');
    if (!b) return;
    const now = Date.now();
    if (now - lastCheckout < 2000) return;
    lastCheckout = now;
    if (lastCart) sendCheckout(lastCart);
    else refreshCart().then(sendCheckout).catch(() => {});
  }, true);
})();
